import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { MatMenu, MatMenuTrigger } from '@angular/material/menu';
import { MediaQueryService } from '../../services/media.query/media.query.service';

@Component({
  selector: 'ig-accordion',
  templateUrl: './accordion.component.html',
  styleUrls: ['./accordion.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class AccordionComponent {
  panelOpenState = false;
  @Input() mode: 'expand' | 'dropdown' = 'expand';
  @Input() canItemClear = true;
  @Input() prefixIcon: string = '';
  @Input() set title(title: string) {
    this.displayTitle = title;
    if (!this.inititalTitle) {
      this.inititalTitle = this.displayTitle;
    }
    this.updateSelectedState();
  }
  @Input() set isSelected(isSelected: boolean | null | undefined) {
    this.selectedOverride = isSelected;
    this.updateSelectedState();
  }
  @Input() canClear: boolean = true;
  @Input() menuClass: string = '';
  @ViewChild('trigger', { static: false }) menuTrigger: ElementRef;
  @ViewChild(MatMenuTrigger, { static: false })
  matMenuTrigger: MatMenuTrigger;
  @ViewChild('menu', { static: false }) menu: MatMenu;

  @Output() public onIconClicked = new EventEmitter();
  @Output() public onMenuOpened = new EventEmitter();
  @Output() public expandedChange = new EventEmitter<boolean>();

  isMenuOpened = false;
  isItemSelected = false;
  inititalTitle: string = null;
  displayTitle: string = null;
  selectedOverride: boolean | null = null;

  constructor(public mediaQueryService: MediaQueryService) {}

  menuOpened() {
    this.isMenuOpened = true;
    this.onMenuOpened.emit();
    this.excludePanelFromHostSmoothScroll();
    const rect = this.menuTrigger.nativeElement.getBoundingClientRect();
    const menu = document.querySelector('.ig-accordion-menu');

    if (!menu || !rect) return;

    (menu as HTMLElement).style.width = rect.width + 'px';
    (menu as HTMLElement).style.maxWidth = rect.width + 'px';

    this.onMenuOpened.emit();
  }

  closeMenu() {
    this.matMenuTrigger?.closeMenu();
  }

  iconClicked($event: Event) {
    const shouldClear =
      this.mode === 'expand' ? this.isItemSelected : this.isItemSelected && !this.isMenuOpened;

    if (!shouldClear) {
      return;
    }

    $event.preventDefault();
    $event.stopPropagation();
    this.onIconClicked.emit();
  }

  /**
   * Resets the initial title to the current display title.
   * This forces the accordion to treat the current title as the "neutral" state,
   * removing the "selected" visual state.
   */
  resetInitialTitle() {
    this.inititalTitle = this.displayTitle;
    this.isItemSelected = false;
  }

  private excludePanelFromHostSmoothScroll() {
    const panelId = this.menu?.panelId;
    const panel = panelId ? document.getElementById(panelId) : null;
    panel?.setAttribute('data-lenis-prevent', '');
  }

  private updateSelectedState() {
    if (this.selectedOverride !== null && this.selectedOverride !== undefined) {
      this.isItemSelected = this.canItemClear && this.selectedOverride;
      return;
    }

    this.isItemSelected = this.canItemClear && this.inititalTitle !== this.displayTitle;
  }
}
